import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Base section component with consistent padding and optional backgrounds
const Section = styled(Box, {
  shouldForwardProp: (prop) =>
    !['variant', 'noPadding', 'fullHeight'].includes(prop),
})(({ theme, variant = 'default', noPadding = false, fullHeight = false }) => ({
  position: 'relative',
  width: '100%',
  minHeight: fullHeight ? '100vh' : 'auto',
  paddingTop: noPadding ? 0 : theme.spacing(12),
  paddingBottom: noPadding ? 0 : theme.spacing(12),
  overflow: 'hidden',

  [theme.breakpoints.down('md')]: {
    paddingTop: noPadding ? 0 : theme.spacing(8),
    paddingBottom: noPadding ? 0 : theme.spacing(8),
  },

  [theme.breakpoints.down('sm')]: {
    paddingTop: noPadding ? 0 : theme.spacing(6),
    paddingBottom: noPadding ? 0 : theme.spacing(6),
  },

  // Variant styles
  ...(variant === 'default' && {
    backgroundColor: theme.palette.background.default,
  }),

  ...(variant === 'light' && {
    backgroundColor: theme.palette.grey[50],
  }),

  ...(variant === 'dark' && {
    backgroundColor: theme.palette.background.dark,
    color: theme.palette.text.light,
  }),

  ...(variant === 'gradient' && {
    background: theme.palette.background.hero,
    color: theme.palette.text.light,
  }),

  ...(variant === 'primary' && {
    background: theme.palette.accent.gradient,
    color: theme.palette.text.light,
  }),
}));

export default Section;
